import { useEffect, useState, useCallback } from "react";
import { UserRoleAssignmentService } from "../../../services";
import { useUrlParams, useAsync } from "../../../hooks";
import { LocationRoleAssignmentModel, OrganizationRoleAssignmentModel, TenantRoleAssignmentModel } from "../../../data/entities";

export function useAccess() {
  const userRoleAssignmentService = new UserRoleAssignmentService();

  const userId = parseInt(useUrlParams("id"));
  const [refreshKey, setRefreshKey] = useState(0);

  const { value: userRoleAssignment, error, loading } = useAsync(() => userRoleAssignmentService.getAll(userId), [userId, refreshKey]);

  const [globalRoles, setGlobalRoles] = useState<string[]>([]);
  const [tenantRoleAssignments, setTenantRoleAssignments] = useState<TenantRoleAssignmentModel[]>();
  const [organizationRoleAssignments, setOrganizationAssignments] = useState<OrganizationRoleAssignmentModel[]>();
  const [locationRoleAssignments, setLocationRoleAssignments] = useState<LocationRoleAssignmentModel[]>();

  useEffect(() => {
    setGlobalRoles(userRoleAssignment?.globalRoleNames ?? []);
    setTenantRoleAssignments(userRoleAssignment?.tenants);
    setOrganizationAssignments(userRoleAssignment?.organizations);
    setLocationRoleAssignments(userRoleAssignment?.locations);
  }, [userRoleAssignment]);

  const refreshData = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1);
  }, []);

  return {
    globalRoles,
    tenantRoleAssignments,
    organizationRoleAssignments,
    locationRoleAssignments,
    loading,
    error,
    refreshData
  }
}
